import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Grid, TextField } from '@material-ui/core';
import { fieldValidation } from '../../../utils/validator';
import { S3_ASSETS_PATH, GOOGLE_RECAPTCHA_SITE_KEY } from '../../../constants';
import regexExpressions from '../../../constants/regexExpressions';
import { toastFlashMessage } from '../../../utils';
import { forgotPasswordApi } from '../apiServices';
import ReCAPTCHA from 'react-google-recaptcha';

export default withRouter(
  class ForgotPasswordForm extends Component {
    constructor(props) {
      super(props);
      this.state = {
        callback: 'not fired',
        grecaptchaResponse: '',
        captchaValueNotSet: true,
        load: false,
        expired: 'false',
        userInfo: {
          email: '',
        },
        error: {},
        errorCode: {
          email: {
            0: '',
            1: 'Please enter Email',
            4: 'Invalid Email',
          },
          emailObj: {
            requiredFlag: true,
            regexPattern: regexExpressions.email,
          },
        },
        loader: false,
      };
    }

    componentDidMount() {
      this.setState({ load: true });
    }

    handleChangeCapcha = (value) => {
      this.setState({ grecaptchaResponse: value, captchaValueNotSet: false });
      if (value === null) this.setState({ expired: true });
    };

    asyncScriptOnLoad = () => {
      this.setState({ load: true });
    };

    handleChange = (value, key) => {
      this.setState((prevState) => ({
        ...prevState,
        userInfo: {
          ...prevState.userInfo,
          [key]: value,
        },
        error: {
          ...prevState.error,
          [key]: '',
        },
      }));
    };

    handleError = (value, key) => {
      const { errorCode } = this.state;
      this.setState((prevState) => ({
        ...prevState,
        error: {
          ...prevState.error,
          [key]:
            errorCode[key][
              fieldValidation({ ...errorCode[`${key}Obj`], fieldval: value })
            ],
        },
      }));
    };

    forgotPassword = (e) => {
      e.preventDefault();
      const { errorCode, userInfo, grecaptchaResponse } = this.state;
      this.setState({
        loader: true,
      });
      const validateNewInput = {
        email:
          errorCode.email[
            fieldValidation({
              ...errorCode.emailObj,
              fieldval: userInfo.email,
            })
          ],
      };
      if (
        Object.keys(validateNewInput).every((k) => {
          return validateNewInput[k] === '';
        }) &&
        grecaptchaResponse
      ) {
        forgotPasswordApi({
          email: userInfo.email.trim(),
          grecaptchaResponse,
        }).then((response) => {
          this.setState({
            loader: false,
          });
          if (response.status >= 200 && response.status < 300) {
            toastFlashMessage('Email has been sent', 'success');
            this.props.history.push('user/reset/successfully');
          }
        });
      } else {
        this.setState({
          error: validateNewInput,
          loader: false,
        });
      }
    };

    handleOnExpired = () => {
      this.setState({
        grecaptchaResponse: null,
        captchaValueNotSet: true,
      });
    };

    handleNetworkError = (err) => {
      this.setState({ grecaptchaResponse: null, captchaValueNotSet: null });
      toastFlashMessage(
        'Network Error, Check you Internet Connection !',
        'error'
      );
    };

    render() {
      const {
        userInfo,
        error,
        loader,
        load,
        grecaptchaResponse,
        captchaValueNotSet,
      } = this.state;
      return (
        <div
          className="auth-user-form forgot-password"
          data-testid="forgotPasswordForm"
        >
          <form onSubmit={this.forgotPassword}>
            <div className="form-title">
              <h3 className="heading1">
                <img src={`${S3_ASSETS_PATH}/images/forgot-pswd.svg`} alt="" />
                {this.props.location.pathname == '/expired-password'
                  ? 'Password expired !'
                  : 'Forgot your password?'}
              </h3>
              <p className="paragraph">
                Enter the email address you used to sign up on{' '}
                <span>campaignregistry.com</span>. We’ll send you a link to
                reset your password.
              </p>
            </div>
            <ul className="list-unstyled">
              <li>
                <div className="form-group-field">
                  <TextField
                    data-testid="forgotPasswordFormEmailInput"
                    error={error.email ? true : false}
                    id="email"
                    label="Email"
                    autoComplete="off"
                    required={true}
                    value={userInfo.email}
                    fullWidth={true}
                    inputProps={{ 'aria-label': 'email' }}
                    onChange={(event) =>
                      this.handleChange(event.target.value, 'email')
                    }
                    onBlur={(event) =>
                      this.handleError(event.target.value, 'email')
                    }
                  />
                  {error.email ? (
                    <h6 className="error-msg">{error.email}</h6>
                  ) : null}
                </div>
              </li>
              <li style={{ textAlign: 'center' }}>
                {
                  <ReCAPTCHA
                    style={{ display: 'inline-block' }}
                    theme="light"
                    ref={this._reCaptchaRef}
                    sitekey={GOOGLE_RECAPTCHA_SITE_KEY}
                    onChange={this.handleChangeCapcha}
                    onExpired={this.handleOnExpired}
                    asyncScriptOnLoad={this.asyncScriptOnLoad}
                    onErrored={this.handleNetworkError}
                  />
                }
              </li>
              <li>
                <div
                  className="form-group-field"
                  style={{ textAlign: 'center' }}
                >
                  <input
                    type="submit"
                    data-testid="forgotPasswordFormSubmitButton"
                    disabled={
                      loader ||
                      Object.keys(error).find((k) => error[k] != '') ||
                      captchaValueNotSet
                        ? true
                        : false
                    }
                    value={'Submit'}
                  />
                </div>
              </li>
            </ul>

            <p
              className="text-center account-link-option"
              data-testid="forgotPasswordFormBackButton"
            >
              Back to <Link to="/login">Login</Link>
            </p>
          </form>
        </div>
      );
    }
  }
);
